"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEffectsDef = void 0;
const parseDef_1 = require("../parseDef");
function parseEffectsDef(_def, refs) {
    return refs.effectStrategy === "input"
        ? (0, parseDef_1.parseDef)(_def.schema._def, refs)
        : {};
}
exports.parseEffectsDef = parseEffectsDef;
